<template>
  <b-modal
    id="create-prospect-template-modal"
    ref="modal"
    class="create-prospect-template-modal"
    size="lg"
    :no-close-on-backdrop="true"
  >
    <div v-if="!templates">
      <Loader />
    </div>

    <div v-else>
      <prospect-template-form
        ref="templateForm"
        :templates="templates"
        :product="product"
        :starting-category="selectedCategory"
        :starting-category-options="initialCategoryOptions"
        :page="newSearchPage"
        :did-select-category="didSelectCategory"
        :on-select-new-template="onSelectNewTemplate"
      />
    </div>

    <template slot="modal-footer">
      &nbsp;

      <button
        v-if="newSearchPage !== 2 && newSearchPage !== 0"
        class="btn"
        @click="goBack()"
      >
        Back
      </button>

      <!--      <button
        v-if="newSearchPage === 2"
        class="btn btn-primary"
        @click="hide()"
      >
        Close
      </button>  -->

      <button
        v-if="newSearchPage === 1 && $refs.templateForm && !$refs.templateForm.creatingNew()"
        type="button"
        class="btn btn-secondary"
        @click="preview()"
      >
        <processing-text :prc="saving">
          Preview Template
        </processing-text>
      </button>

      <button
        v-if="newSearchPage === 1"
        type="button"
        class="btn btn-primary"
        @click="saveTemplate()"
      >
        <processing-text :prc="saving">
          <span v-if="$refs.templateForm.creatingNew()">Next</span>
          <span v-else>Save Template</span>
        </processing-text>
      </button>

      <button
        v-else-if="newSearchPage === 0 && creatingNew"
        type="button"
        class="btn btn-primary"
        @click="saveTemplate()"
      >
        <processing-text :prc="saving">
          Next
        </processing-text>
      </button>
      <!-- <button
        v-else-if="newSearchPage === 8"
        class="btn btn-primary"
        @click="hide()"
      >
        Done
      </button> -->
    </template>
  </b-modal>
</template>

<script>
import ProspectTemplateForm from '@/components/forms/ProspectTemplateForm.vue';
import Loader from '@/components/Loader.vue';
import ProcessingText from '@/components/ProcessingText.vue';

export default {
  name: 'CreateProspectTemplateModal',
  components: {
    ProspectTemplateForm,
    ProcessingText,
    Loader,
  },
  props: {
    afterCreate: {
      type: Function,
    },
  },
  data() {
    return {
      creatingNew: false,
      saving: false,
      product: null,
      selectedCategory: null,
      initialCategoryOptions: null,
      newSearchPage: 0,

      templates: null,
    };
  },
  methods: {
    show(product) {
      this.creatingNew = false;
      this.saving = false;
      this.product = product || null;
      this.newSearchPage = 0;
      this.selectedCategory = null;
      this.templates = null;

      if (this.product && this.product.prospect_template_category_id && this.product.prospect_template_token) {
        this.selectedCategory = this.product.prospect_template_category_id;
      } else if (this.product && this.product.categories.length === 1) {
        this.selectedCategory = this.product.categories[0].id;
      } else if (this.product && this.product.categories.length > 1) {
        this.initialCategoryOptions = this.product.categories;
      }

      if (product && product.prospect_templates) {
        this.templates = product.prospect_templates;
        this.resetTemplatesForm();
      } else if (product) {
        this.$globals.userClient.getProductTemplates(product.id, false).then(res => {
          this.templates = res.items;
          this.resetTemplatesForm();
        }).catch(ex => {
          this.templates = [];
          this.resetTemplatesForm();
        });
      }
      this.$refs.modal.show();
    },
    resetTemplatesForm() {
      setTimeout(() => {
        if (this.$refs.templateForm) {
          this.$refs.templateForm.reset(this.selectedCategory, this.initialCategoryOptions);
        }

        if (!this.templates.length) {
          this.newSearchPage = 1;
        }
      }, 300);
    },
    hide() {
      this.saving = false;
      this.$refs.modal.hide();
    },
    goBack() {
      if (this.newSearchPage) {
        this.newSearchPage = this.newSearchPage - 1;
        this.resetTemplatesForm();
      }
    },
    didSelectCategory() {
      this.newSearchPage = 1;
    },
    goNext() {
      this.newSearchPage = this.newSearchPage + 1;
    },
    preview(url) {
      if (this.$refs.templateForm) {
        this.$refs.templateForm.preview();
      }
    },
    saveTemplate() {
      if (this.$refs.templateForm && this.$refs.templateForm.creatingNew()) {
        this.$refs.templateForm.saveNewTemplate();
      } else {
        if (this.afterCreate) {
          this.afterCreate();
        }
        this.hide();
      }
    },
    onSelectNewTemplate(creatingNew) {
      this.creatingNew = creatingNew;
    },
  },
};
</script>

<style lang="scss">
.big-option {
  width: 100%;
  text-align: left;
  margin-bottom: 5px;
  position: relative;
  height: 70px;

  .fa-search,
  .fa-chart-line,
  .fa-user-chart,
  .fa-ballot-check,
  .fa-usd-square {
    margin-right: 10px;
    margin-right: 15px;
    font-size: 21px;
    position: relative;
    top: 3px;
  }

  .right {
    position: absolute;
    right: 15px;
    top: 23px;
  }

  &.capped {
    @media (min-width: $md-min) {
      width: auto;
      min-width: 250px;
      margin-left: 5px;
      margin-right: 5px;
    }

    &.main {
      background: $blue;
      border-color: $blue;
      color: white;

      &:hover {
        background: darken($blue, 5%);
        border-color: darken($blue, 5%);
      }
    }
  }
}

.step-number {
  margin-top: 30px;
  opacity: 0.6;
  margin-bottom: 0;
}

a.big-option {
  padding-top: 17px;
}

.input-with-close {
  .left {
    display: inline-block;
    vertical-align: top;
    width: calc(100% - 65px);
  }

  .right {
    display: inline-block;
    vertical-align: top;
    width: 61px;

    .btn {
      height: 60px;
      width: 60px;
      margin-left: 5px;
    }
  }
}
</style>
